import { LinearGradient } from 'expo-linear-gradient';
import React, { useState } from 'react';
import { ActivityIndicator, FlatList, Image, ScrollView, View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../globalComponents/NativeOverrides"
import { comps_getCompetitionByCode } from '../../store/actionsv1/comps';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import CompetitionCodeModal from './components/CompetitionCodeModal';
import { AdminCompetitionList, CreateCompetitionForm, CreateSeasonForm, EngageModule } from 'be-components';


const CompetitionHomeScreen = ({route, navigation}:any) => {
    const [ show_admin_list, setShowAdminList ] = useState(false);
    const [ show_create_competition, setShowCreateCompetition ] = useState(false);
    const [ show_create_season, setShowCreateSeason ] = useState(false);
    const [ code_enter_visible, setCodeEnterVisible ] = useState(false);
    const [ button_height, setButtonHeight ] = useState(20);

    const dispatch = useDispatch();
    const header_height = useSelector((state:any) => state.util.header_height, (left, right) => left == right);
    const bottom_tab_height = useSelector((state:any) => state.util.bottom_tab_height, (left, right) => left == right);

    const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)


    const handleCodeEnter = async(code:string) => {
        setCodeEnterVisible(false)
        await dispatch(comps_getCompetitionByCode(code, navigation))
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <View style={{ flex:1 }}>
                <EngageModule
                    player_id={player?.player_id}
                    onManage={() => setShowAdminList(true)}
                    onSelectCompany={(c) => navigation.navigate('SocialStack', { screen: 'CompanyProfile', initial:false, params: { company_id:c.company_id } })}
                    onCreateSeason={player?.role == 'admin' ? () => setShowCreateSeason(true) : undefined}
                    onSelectBracketCompetition={(bc) => navigation.push('BracketPlay', { bracket_competition_id: bc.bracket_competition_id })}
                    onSelectCompetition={(c) => navigation.push('CompetitionPlay', { competition_id: c.competition_id })}
                    onSelectSquaresCompetition={(sc) => navigation.push('SquaresPlay', { sq_comp_id:sc.sq_comp_id })}
                    onSelectCompetitionSeason={(cs) => navigation.push('CompetitionSeason', { competition_season_id: cs.competition_season_id })}
                />
            </View>
            <CompetitionCodeModal isVisible={code_enter_visible} closeModal={() => setCodeEnterVisible(false)} onEnter={(code) => handleCodeEnter(code)}/>

            {show_create_season ?
            <View style={{ position:'absolute', top:0, bottom:0, right:0, left:0, justifyContent:'flex-end', backgroundColor:Colors.shades.black_faded }}>
                <View style={{ borderTopRightRadius:22, borderTopLeftRadius:22, paddingTop:20, backgroundColor:Colors.shades.white, maxHeight: app_size.height }}>
                    <CreateSeasonForm
                        width={app_size.width}
                        onClose={() => setShowCreateSeason(false)}
                        onCreateSeason={(cs) => {
                            setShowCreateSeason(false);
                            navigation.push('CompetitionSeason', { competition_season_id:cs.competition_season_id, mode: 'manage' })
                        }}
                    />
                </View>
            </View>
            :<></>}
            {show_create_competition ?
            <View style={{ position:'absolute', top:0, bottom:0, right:0, left:0, justifyContent:'flex-end', backgroundColor:Colors.shades.black_faded }}>
                <View style={{ borderTopRightRadius:22, borderTopLeftRadius:22, paddingTop:20, backgroundColor:Colors.shades.white, maxHeight: app_size.height }}>
                    <CreateCompetitionForm
                        width={app_size.width}
                        onClose={() => setShowCreateCompetition(false)}
                        onCreate={(competition) => {
                            navigation.push('CompetitionPlay', { competition_id:competition.competition_id, mode: 'manage' })
                            setShowCreateCompetition(false);
                        }}
                    />
                </View>
            </View>
            :<></>}
            {show_admin_list ?
            <View style={{ position:'absolute', top:0, bottom:0, right:0, left:0, justifyContent:'flex-end', backgroundColor:Colors.shades.black_faded }}>
                <View style={{ borderTopRightRadius:22, borderTopLeftRadius:22, paddingTop:20, backgroundColor:Colors.shades.white, maxHeight: app_size.height }}>               
                <AdminCompetitionList
                    width={app_size.width}
                    height={app_size.height - header_height - bottom_tab_height}
                    onClose={() => setShowAdminList(false)}
                    onCreateNew={() => {
                        setShowAdminList(false);
                        setShowCreateCompetition(true);
                    }}
                    onSelectCompetition={(c) => navigation.push('CompetitionPlay', { competition_id:c.competition_id })}
                    onSelectSquaresCompetition={(sc) => navigation.push('SquaresPlay', { sq_comp_id: sc.sq_comp_id })}
                    onSelectBracketCompetition={(bc) => navigation.push('BracketPlay', { bracket_competition_id:bc.bracket_competition_id })}
                />
                </View>
            </View>
            :<></>}
        </View>
    )
}

const local_styles = {
    raised: { shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 3.84, elevation: 5 }
}

export default CompetitionHomeScreen